/**
 *
 *
 *
 */
import React from 'react';
import styled from 'styled-components';


/**
 *
 *
 *
 */
export default function ProfileUser(props) {

  return (
    <S.Container>
      User
    </S.Container>
  );
}


/**
 *
 *
 *
 */
const S = {};

S.Container = styled.div``;